export default (scrollTo = hash => {
  //Reset in case it contains the old hash
  if (window.location.hash === '#' + hash) {
    window.location.hash = '';
  }
  window.location.hash = '#' + hash;
});
